/**
 * @desc: форматриует число в виде валюты
 * @param {number} num
 * @return {string} строка с отформатированным значением
 */
const getLocalCurrencyStr = (num: number) => {
  if (!num || typeof num !== 'number') {
    return '';
  }
  return num
    .toLocaleString('ru-RU', {
      style: 'currency',
      currency: 'rub',
    })
    .replace(',00', '');
};

export default getLocalCurrencyStr;
